module.exports = __webpack_public_path__ + "assets/ee9b6de6cd9dc254b1c47487adbdf0a3.mp3";